import { useEffect } from 'react';

const GoogleTagManager = () => {
  useEffect(() => {
    // Only initialize GA4 in production
    if (process.env.NODE_ENV === 'production') {
      const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-NNMRP0E7GW';

      // Load gtag.js script
      const script1 = document.createElement('script');
      script1.async = true;
      script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
      document.head.appendChild(script1);

      // Initialize gtag
      const script2 = document.createElement('script');
      script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${GA_ID}');
      `;
      document.head.appendChild(script2);

      console.log('✅ Google Analytics 4 initialized');
    } else {
      console.log('🔧 GA4 skipped - Development mode');
    }
  }, []);

  return null;
};

export default GoogleTagManager;